import { CurrencyPipe, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { ACNPipe } from "@shared/pipes/acnPipe";
import { CountryPipe } from "@shared/pipes/countryPipe";
import { DateFormatPipe } from "@shared/pipes/dateFormatPipe";
import { DocumentTypePipe } from "@shared/pipes/document-type.pipe";
import { ShareTypePipe } from "@shared/pipes/share-type.pipe";

@NgModule({
  providers: [
    DatePipe,
    CurrencyPipe,
    ShareTypePipe,
    CountryPipe,
    DocumentTypePipe,
    DateFormatPipe,
    ACNPipe
  ],
})
export class AppPipesModule {
}
